import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import {
  DirectionsCar as CarIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as MoneyIcon,
  Percent as PercentIcon
} from '@mui/icons-material';

const stats = [
  { key: 'totalVehicles', label: 'Total Vehicles', icon: <CarIcon />, color: '#1976d2' },
  { key: 'goodDeals', label: 'Good Deals', icon: <TrendingUpIcon />, color: '#2e7d32' },
  { key: 'avgSavings', label: 'Avg Savings', icon: <MoneyIcon />, color: '#ed6c02', prefix: '$' },
  { key: 'avgDiscount', label: 'Avg Discount', icon: <PercentIcon />, color: '#9c27b0', suffix: '%' },
];

function StatsCards({ totalVehicles, goodDeals, avgSavings, avgDiscount }) {
  const values = { totalVehicles, goodDeals, avgSavings, avgDiscount };

  return (
    <Grid container spacing={2}>
      {stats.map((stat) => (
        <Grid item xs={6} md={3} key={stat.key}>
          <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
            <Box sx={{ mr: 2, color: stat.color }}>{stat.icon}</Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                {stat.label}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {stat.prefix || ''}
                {typeof values[stat.key] === 'number'
                  ? values[stat.key].toLocaleString(undefined, { maximumFractionDigits: 1 })
                  : values[stat.key] || 0}
                {stat.suffix || ''}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}

export default StatsCards;
